import React, {Component} from 'react';
import {
    AlertModal,
    CCText,
    Modal,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import AppConfig from '../../../AppConfig';

import DefaultButton, {DarkButton, ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import TMenuItem from './Translations/TMenuItem';

import {QRCodeSVG} from 'qrcode.react';

import domtoimage from "dom-to-image";
import PencilIcon from "../../../assets/custom-icons/PencilIcon";
import ToggleOnIcon from "../../../assets/custom-icons/ToggleOnIcon";
import ToggleOffIcon from "../../../assets/custom-icons/ToggleOffIcon";
import QRCodeWrapper from "../../../custom-packages/QRCodeWrapper/QRCodeWrapper";
import QRCodeModal from "../../../custom-packages/QRCodeWrapper/QRCodeModal";

export default class MenuItem extends Component {

    qrCodeRef;

    constructor(props) {
        super(props);

        this.state = {
            menu: this.props.item,
            isEditModalOpen: this.props.item.openEditor ? true : false,
            isQrCodeModalOpen: false,
            isImportModalOpen: false,
            toggleLoading: false,
            importing: false,
            deleted: false,
        };

        this.toggleEditModal = this.toggleEditModal.bind(this);
        this.toggleQrCodeModal = this.toggleQrCodeModal.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        let shouldUpdate = false;

        if (nextState.toggleLoading != this.state.toggleLoading) {
            shouldUpdate = true;
        } else if (nextState.menu.men_name != this.state.menu.men_name) {
            shouldUpdate = true;
        } else if (nextState.menu.men_active != this.state.menu.men_active) {
            shouldUpdate = true;
        } else if (nextState.deleted != this.state.deleted) {
            shouldUpdate = true;
        } else if (nextState.isEditModalOpen != this.state.isEditModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isEditModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isQrCodeModalOpen != this.state.isQrCodeModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isQrCodeModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isImportModalOpen != this.state.isImportModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isImportModalOpen) {
            shouldUpdate = true;
        }

        return shouldUpdate;
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        const showPremium = false
        if (this.state.deleted) {
            return null;
        }

        return <View>
            <View className="card-mobile">
                <div className={'card-body'}>
                    <View className="row">
                        <View className="col-12 col-md-6 col-lg-7 td mobile-margin-bottom">
                            <h4>
                                {this.state.menu.men_name}
                            </h4>
                        </View>
                        <View className="col-12 col-md-6 col-lg-5 td" style={{ justifyContent: 'flex-end', flexDirection: 'row' }}>
                            {showPremium ?
                                <DefaultButton
                                    icon={this.state.menu.men_active ? <ToggleOnIcon size={25} /> : <ToggleOffIcon size={25} />}
                                    text={this.state.menu.men_active ? TMenuItem[AppConfig.lang].ENABLED : TMenuItem[AppConfig.lang].DISABLED}
                                    onPress={this.ToggleMenu.bind(this, this.state.menu)}
                                />
                                :
                                null
                            }
                            <View style={{ width: 7 }}></View>
                            {this.state.menu.men_active ?
                                <ThemeButton
                                    text={TMenuItem[AppConfig.lang].QR_CODE}
                                    onPress={this.toggleQrCodeModal.bind(this)}
                                />
                                :
                                null
                            }
                            <View style={{ width: 7 }}></View>
                            <DarkButton
                                icon={<PencilIcon size={25} color={'white'} />}
                                text={TMenuItem[AppConfig.lang].EDIT}
                                to={'/admin/menu/editor/' + this.state.menu.men_id}
                            />
                        </View>
                    </View>
                </div>
            </View>
            <input
                ref={(r) => this.inputFile = r}
                style={{ display: 'none' }}
                type="file"
                name="item"
                accept=".png,.jpg,.jpeg,.pdf"
                onChange={this.ImportMenu.bind(this)}
            />
            <AlertModal
                visible={this.state.isImportModalOpen}
                onRequestClose={this.toggleImportModal.bind(this)}
                title={TMenuItem[AppConfig.lang].IMPORT_MENU}
                text={TMenuItem[AppConfig.lang].IMPORT_MENU_TEXT}
                buttons={[
                    {
                        text: TMenuItem[AppConfig.lang].CANCEL,
                        onPress: () => {}
                    },
                    {
                        text: TMenuItem[AppConfig.lang].IMPORT,
                        onPress: () => {
                            this.inputFile.click();
                        }
                    }
                ]}
            />
            <QRCodeModal
                visible={this.state.isQrCodeModalOpen}
                onRequestClose={this.toggleQrCodeModal.bind(this)}
                menu={this.state.menu}
            />
        </View>;
    }

    async ChangeFoodImage() {
        this.inputFile.click();
    }

    toggleQrCodeModal() {
        this.setState(
            (prevState) => ({ isQrCodeModalOpen: !prevState.isQrCodeModalOpen }),
        );
    }

    toggleEditModal() {
        this.setState(
            (prevState) => ({ isEditModalOpen: !prevState.isEditModalOpen }),
        );
    }

    toggleImportModal() {
        this.setState({
            isImportModalOpen: !this.state.isImportModalOpen
        })
    }

    async ImportMenu(event) {
        if (event.target.files.length > 0) {
            this.setState({
                importing: true
            })

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });

            const image = await toBase64(event.target.files[0]);

            const response = await fetch(AppConfig.URL + "/Menu/ImportMenu/" + this.state.menu.men_id, {
                method: 'POST',
                body: JSON.stringify({
                    Image: image,
                    Type: 'HQ'
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.props.Auth.token
                }
            });

            const r = await response.json();

            if (r.success) {
                const business = { ...this.state.business };

                business.buS_LOGO = image;

                this.setState({
                    business: business
                });
            }

            this.setState({
                importing: false
            })
        }
    }

    async ToggleMenu() {
        const menu = { ...this.state.menu };

        menu.men_active = !menu.men_active;

        this.setState({
            toggleLoading: true,
            menu: menu
        });

        const response = await fetch(AppConfig.URL + "/Menu/Toggle/" + menu.men_id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.Auth.token
            }
        });

        const r = await response.json();

        if (r.success) {
            this.setState({
                toggleLoading: false,
            });
        }
    }

    async DeleteFood() {
        /*Alert.alert(
            TFoodItem[AppConfig.lang].DELETE_FOOD_TITLE,
            TFoodItem[AppConfig.lang].DELETE_FOOD_TEXT,
            [
                {
                    text: TFoodItem[AppConfig.lang].CANCEL,
                    onPress: () => { },
                    style: "cancel"
                },
                {
                    text: TFoodItem[AppConfig.lang].CONFIRM_DELETE_FOOD_TEXT,
                    onPress: async () => {
                        const response = await fetch(AppConfig.URL + "/Food/Delete/" + this.state.food.foO_ID, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': this.props.Auth.token
                            }
                        });

                        const r = await response.json();

                        if (r.success) {
                            this.setState({
                                deleted: true 
                            });
                        }
                    }
                }
            ]
        );*/
    }
}